import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=8c547540&scoped=true&"
import script from "./UnderReview.vue?vue&type=script&lang=js&"
export * from "./UnderReview.vue?vue&type=script&lang=js&"
import style0 from "./UnderReview.vue?vue&type=style&index=0&id=8c547540&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c547540",
  null
  
)

export default component.exports